import type { AuthFeature, ShellBrand } from '@bixo/ui'
import {
  BarChart3,
  Boxes,
  Handshake,
  Lock,
  ReceiptIndianRupee,
  ScanBarcode,
  ShieldCheck,
  Zap,
} from 'lucide-react'

/** The Bixo logo, generated by tools/brand/make_brand_assets.py into public/brand. */
export const bixoWordmark = {
  light: '/brand/wordmark-320.webp',
  dark: '/brand/wordmark-on-dark-320.webp',
  width: 320,
  height: 104,
}

/** The platform's brand-panel content, shared by sign-in, sign-up and password pages. */
export const platformBrand: ShellBrand = {
  name: 'Bixo',
  logoUrl: '/brand/mark-64.png',
  wordmark: bixoWordmark,
}

export const platformFeatures: AuthFeature[] = [
  {
    icon: ReceiptIndianRupee,
    title: 'GST billing in seconds',
    text: 'Tax invoices in A4 and thermal, shared on WhatsApp.',
  },
  {
    icon: ScanBarcode,
    title: 'A POS that keeps up',
    text: 'Scan from any phone, with search that forgives typos.',
  },
  {
    icon: Boxes,
    title: 'Inventory that reconciles',
    text: 'Landed cost, batches, serials and labels with prices.',
  },
  {
    icon: Handshake,
    title: 'Partners and SIs',
    text: 'Referral and resale margins, earned as invoices get paid.',
  },
  {
    icon: BarChart3,
    title: 'Reports you trust',
    text: 'Ledgers, outstanding, P&L and GSTR-1 / 3B summaries.',
  },
]

export const platformBadges = [
  { icon: Lock, label: 'Encrypted' },
  { icon: ShieldCheck, label: 'Audited' },
  { icon: Zap, label: 'Two-factor sign-in' },
]
